module.exports = __webpack_public_path__ + "static/media/remixicon.f3686cbd.svg";